export const formOrikomi = () => {
    $(function () {

        // 数字をカンマ付きにする
        function commaSeparated(num) {
            return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        }

        // APIのURLを初期化
        const apiUrl = "https://orikomitry.jp/_app/api";

        // 合計額を設定
        function setCal() {
            var orikmiPrice = Number($('.js-orikomi-price-data').val());
            var insatsuPrice = Number($('.js-insatsu-price-data').val());
            var designPrice = Number($('.js-design-price-data').val());
            $('.js-orikomi-subtotal').html(commaSeparated(orikmiPrice + insatsuPrice + designPrice));
        }

        setCal();

        // オリコミ費用を動的に出力
        function setOrikomiPrice() {
            var pref_id = $('input[name="prefId"]').val();
            var city_id = $('input[name="cityId"]').val();
            var size_id = $('input[name="sizeId"]').val();
            var sheet_num = $('input[name="sheet"]').val();

            if (pref_id !== "" && city_id !== "" && sheet_num !== "") {
                //コンテンツ読み込み
                $.ajax({
                    url: apiUrl + '/getOrikomiPrice?pref_id=' + pref_id + '&city_id=' + city_id + '&size_id=' + size_id,
                    dataType: 'json'
                }).done(function (data) {
                    if (data !== false) {
                        $('.js-orikomi-price-data').val((data.data * sheet_num) / 1000)
                        $('.js-orikomi-price').html(commaSeparated((data.data * sheet_num) / 1000) + '円')
                    }
                    setCal();
                    setCalTotalAll();
                }).fail(function () {
                    console.log('error');
                });

            } else {
                $('.js-orikomi-price-data').val(0)
                $('.js-orikomi-price').html("0円")
                setCal();
                setCalTotalAll();
            }


        }


        // 印刷費をセット
        function setInsatsuPrice() {

            var size_id = $('input[name="sizeId"]').val();
            var sheet_id = $('input[name="sheetId"]').val();
            var print_type_id = $('input[name="printTypeId"]').val();
            var print = $('input[name="print"]:checked').val();

            if (print == 1 && size_id !== "" && sheet_id !== "" && print_type_id !== "") {
                //コンテンツ読み込み
                $.ajax({
                    url: apiUrl + '/getInsatsuPrice?size_id=' + size_id + '&sheet_id=' + sheet_id + '&print_type_id=' + print_type_id,
                    dataType: 'json'
                }).done(function (data) {
                    if (data !== false) {
                        $('.js-insatsu-price-data').val(data.data)
                        $('.js-insatsu-price').html(commaSeparated(data.data) + '円')
                    }
                    setCal();
                    setCalTotalAll();
                }).fail(function () {
                    console.log('error');
                });

            } else {
                $('.js-insatsu-price-data').val(0)
                $('.js-insatsu-price').html("0円")
                setCal();
                setCalTotalAll();
            }
        }

        // デザイン費用をセット
        function setDesignPrice() {

            var design = $('input[name="design"]:checked').val();
            var size_id = $('input[name="sizeId"]').val();
            var print_type_class = $('input[name="printTypeClass"]').val();

            if (design == 1 && print_type_class !== "") {
                //コンテンツ読み込み
                $.ajax({
                    url: apiUrl + '/getDesignPrice?size_id=' + size_id + '&class=' + print_type_class,
                    dataType: 'json'
                }).done(function (data) {
                    if (data !== false) {
                        $('.js-design-price-data').val(data.data)
                        $('.js-design-price').html(commaSeparated(data.data) + '円')
                    }
                    setCal();
                    setCalTotalAll();
                }).fail(function () {
                    console.log('error');
                });

            } else {
                $('.js-design-price-data').val(0)
                $('.js-design-price').html("0円")
                setCal();
                setCalTotalAll();
            }
        }

        // ----------------------------------
        // タブを切り替える
        // ----------------------------------
        $("#js-tab li").click(function () {
            $("#js-tab li").removeClass("active");
            $(this).addClass("active");
            var index = $(this).index();

            $(".tab-content").removeClass("active");
            $(".tab-content").eq(index).addClass("active");
        });

        // ----------------------------------
        // モーダルが開いているときにモーダル要素以外の要素を押下したときにモーダルを閉じる処理
        // ----------------------------------
        $(document).on('click', function (e) {
            if ($('body').hasClass('modal-active')) {
                if (!$(e.target).closest('.modal-window').length && !$(e.target).closest('.modal-window--ttl').length && $(e.target).closest('#overlay').length) {
                    $('#overlay, .modal-window, .modal-window--ttl').fadeOut();
                    $('body').removeClass('modal-active');  // 本文の縦スクロールを無効
                }
            }
        });

        // ----------------------------------
        // モーダルをフォーカスで開く
        // ----------------------------------
        $('.js-focus-open').focusin(function () {
            if (!$('body').hasClass('modal-active')) {
                var targetModal = '.' + $(this).data('target');
                var targetModalTtl = '.' + $(this).data('target') + "--ttl";
                $('#overlay, ' + targetModal + ',' + targetModalTtl).fadeIn();
                $('body').addClass('modal-active');  // 本文の縦スクロールを無効
            }
        });



        // ----------------------------------
        // モーダルを閉じるボタンを押下したときの処理
        // ----------------------------------
        $('.js-close').click(function () {
            $('#overlay, .modal-window, .modal-window--ttl').fadeOut();
            $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
        });




        // ----------------------------------
        // 地区で使う新聞のデータを取得
        // ----------------------------------
        var paperDatas = []; // 新聞のデータを初期化


        //コンテンツ読み込み
        $.ajax({
            url: apiUrl + '/getPaper',
            dataType: 'json'
        }).done(function (data) {
            paperDatas = data;
            jsClick(paperDatas);
        }).fail(function () {
            console.log('error');
        });

        // ----------------------------------
        // モーダルの要素クリック時の処理（新聞のデータ取得ajaxが終わったら実行）
        // ----------------------------------
        function jsClick(paperDatas) {

            $(".js-click").on('click', function () {
                // $('.js-cal-todal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 全合計のローダーを回す

                switch ($(this).data('item')) {
                    // ----------------------------------
                    // モーダルの要素クリック時の処理
                    // ----------------------------------
                    case 'pref':
                        // // ----------------------------------
                        // // 価格テキスト箇所にローダーを回す
                        // // ----------------------------------
                        // $('.js-orikomi-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミ費のローダーを回す
                        // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
                        // ----------------------------------
                        // 都道府県選択
                        // ----------------------------------
                        $('.js-set-pref').val($(this).data('pref-name'));
                        $('#overlay, .pref-modal, .pref-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効

                        var prefId = $(this).data('pref-id');

                        $('input[name="prefId"]').val(prefId);


                        $.ajax({
                            url: apiUrl + '/getCity?pref_id=' + prefId,
                            dataType: 'json'
                        }).done(function (data) {
                            var city_el = '';

                            $.each(data['data'], function (index, value) {
                                var paperIds = value['paper_ids'].split(',');

                                city_el += '<li class="js-click js-city" data-item="city" data-city-id="' + value['id'] + '" data-city-name="' + value['name'];
                                if (paperIds[0] !== "") {
                                    $.each(paperIds, function (index, value) {
                                        var foundPaper = paperDatas['data'].find(e => e.id === value);
                                        if (foundPaper !== undefined) {
                                            if (foundPaper.name !== undefined) {
                                                city_el += ' ' + foundPaper.name;
                                            }
                                        }
                                    })
                                }
                                city_el += '">' + value['name'];


                                if (paperIds[0] !== "") {
                                    $.each(paperIds, function (index, value) {
                                        var foundPaper = paperDatas['data'].find(e => e.id === value);
                                        if (foundPaper !== undefined) {
                                            if (foundPaper.name !== undefined) {
                                                city_el += '<div class="paper-label-content">' + '<span class="paper-label">' + foundPaper.name + '</span>' + '</div>';
                                            }
                                        }
                                    })
                                }

                            })
                            city_el += '</li>';

                            $(".js-city-datas").html(city_el);


                        }).fail(function () {
                            console.log('error');
                        });
                        $('.js-set-city').val('');
                        $('input[name="cityId"]').val('');
                        break;

                    case 'sheet':
                        // ----------------------------------
                        // 価格テキスト箇所にローダーを回す
                        // ----------------------------------
                        // $('.js-orikomi-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミ費のローダーを回す
                        // $('.js-insatsu-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 印刷費のローダーを回す
                        // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
                        // ----------------------------------
                        // チラシ枚数選択
                        // ----------------------------------
                        $('.js-set-sheet').val($(this).data('sheet-num'));
                        $('input[name="sheetId"]').val($(this).data('sheetId'));
                        $('#overlay, .sheet-modal, .sheet-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効

                        break;

                    case 'size':
                        // ----------------------------------
                        // 価格テキスト箇所にローダーを回す
                        // ----------------------------------
                        // $('.js-orikomi-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミ費のローダーを回す
                        // $('.js-insatsu-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 印刷費のローダーを回す
                        // $('.js-design-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // デザイン費のローダーを回す
                        // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
                        // ----------------------------------
                        // サイズ選択
                        // ----------------------------------
                        $('.js-set-size').val($(this).data('size'));
                        $('input[name="sizeId"]').val($(this).data('sizeId'));
                        $('#overlay, .size-modal, .size-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;
                    case 'printType':
                        // ----------------------------------
                        // 価格テキスト箇所にローダーを回す
                        // ----------------------------------
                        // $('.js-insatsu-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 印刷費のローダーを回す
                        // $('.js-design-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // デザイン費のローダーを回す
                        // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
                        // ----------------------------------
                        // 印刷種類
                        // ----------------------------------
                        $('.js-set-print-type').val($(this).data('printType'));
                        $('input[name="printTypeId"]').val($(this).data('printTypeId'));
                        $('input[name="printTypeClass"]').val($(this).data('printTypeClass'));
                        $('#overlay, .print-type-modal, .print-type-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;
                }
                setOrikomiPrice();
                setInsatsuPrice();
                setDesignPrice();
                setCalTotalAll();
            });

        }

        // ----------------------------------
        // 動的に生成したcity要素をクリックしたときの処理
        // ----------------------------------
        $(document).on('click', '.js-city', function () {
            // ----------------------------------
            // 価格テキスト箇所にローダーを回す
            // ----------------------------------
            // $('.js-orikomi-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミ費のローダーを回す
            // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
            // $('.js-cal-todal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 全合計のローダーを回す
            $('.js-set-city').val($(this).data('city-name'));
            $('input[name="cityId"]').val($(this).data('cityId'));
            $('#overlay, .city-modal, .city-modal--ttl').fadeOut();
            $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
            setOrikomiPrice();
        });

        // ----------------------------------
        // チラシ印刷込みにチェックが入ったとき
        // ----------------------------------
        $('input[name="print"]').on('change',function () {
            // ----------------------------------
            // 価格テキスト箇所にローダーを回す
            // ----------------------------------
            // $('.js-insatsu-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 印刷費のローダーを回す
            // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
            // $('.js-cal-todal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 全合計のローダーを回す
            if ($('input[name="print"]').prop('checked') == true) {
                $('.js-set--print').val('1'); // form-calTotalに代入
				$('.js-err-msg--print').removeClass('is-none'); // ラジオボタンのチェックがどちらかがTrueなら有効
            } else {
                $('.js-set--print').val(''); // form-calTotalに代入
				if($('input[name="design"]').prop('checked') == true) {
					$('.js-err-msg--print').removeClass('is-none'); // ラジオボタンのチェックがどちらかがTrueなら有効
				} else {
					$('.js-err-msg--print').addClass('is-none');
				}
            }

            setInsatsuPrice();
            setCal();
            setCalTotalAll();
        });

        // ----------------------------------
        // デザインにチェックが入ったとき
        // ----------------------------------
        $('input[name="design"]').on('change',function () {
            // ----------------------------------
            // 価格テキスト箇所にローダーを回す
            // ----------------------------------
            // $('.js-design-price').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // デザイン費のローダーを回す
            // $('.js-orikomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // オリコミフォーム合計のローダーを回す
            // $('.js-cal-todal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 全合計のローダーを回す
            if ($('input[name="design"]').prop('checked') == true) {
                $('.js-set--design').val('1'); // form-calTotalに代入
				$('.js-err-msg--print').removeClass('is-none'); // ラジオボタンのチェックがどちらかがTrueなら有効
            } else {
                $('.js-set--design').val(''); // form-calTotalに代入
				if($('input[name="print"]').prop('checked') == true) {
					$('.js-err-msg--print').removeClass('is-none'); // ラジオボタンのチェックがどちらかがTrueなら有効
				} else {
					$('.js-err-msg--print').addClass('is-none');
				}
            }
            setDesignPrice();
            setCal();
            setCalTotalAll();
        });


    });
};